module.exports = __webpack_public_path__ + "img/tredz-havebike-lockoff.62b5de6f.png";